/** Digitizing options (kept separate so the UI can import them without the image pipeline). */
export interface DigitizeOptions {
  /** Target design width in mm (height follows the aspect ratio). */
  widthMm: number;
  /** Number of colours for automatic reduction. */
  colorCount: number;
  /** Fixed palette (hex) from the analysis step, after the user merged/removed/reordered colours. */
  palette?: string[];
  /** Palette indices that are not stitched (treated as background). */
  excluded?: number[];
  /** Per palette index: target palette index (merge) or −1 (not stitched). Applied after assignment. */
  remap?: number[];
  /** Palette indices in the desired sewing order (default: largest area first). */
  colorOrder?: number[];
  alphaThreshold: number;
  removeBackground: boolean;
  backgroundTolerance: number;
  /** Longest side of the working raster in pixels. */
  maxWorkingSize: number;
  /** Regions smaller than this (as a square of side minDetailMm) are merged into neighbours. */
  minDetailMm: number;
  /** 0 = exact pixel contours, 3 = very smooth. */
  smoothness: number;
  allowSatin: boolean;
  satinMaxWidthMm: number;
  runningMaxWidthMm: number;
  fillAngle: number;
  overlapMm: number;
  seed: number;
}

export const defaultDigitizeOptions = (): DigitizeOptions => ({
  widthMm: 90,
  colorCount: 6,
  alphaThreshold: 128,
  removeBackground: true,
  backgroundTolerance: 12,
  maxWorkingSize: 900,
  minDetailMm: 1.2,
  smoothness: 1,
  allowSatin: true,
  satinMaxWidthMm: 6,
  runningMaxWidthMm: 0.9,
  fillAngle: 45,
  overlapMm: 0.25,
  seed: 7,
});

